import { Link } from 'react-router-dom'

const navigation = {
  product: [
    { name: 'Features', href: '/features' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'Security', href: '/features#security' },
    { name: 'Integrations', href: '/features#integrations' },
  ],
  company: [
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
    { name: 'Careers', href: '/about#careers' },
    { name: 'Blog', href: '/blog' },
  ],
  legal: [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Cookie Policy', href: '/cookies' },
  ],
  social: [
    { name: 'LinkedIn', href: 'https://linkedin.com/company/clarantis', external: true },
    { name: 'Twitter', href: 'https://twitter.com/clarantis', external: true },
  ],
}

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-primary-700" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          {/* Brand section */}
          <div className="space-y-8 xl:col-span-1">
            <Link to="/" className="inline-block">
              <img
                src="/logos/clarantis-logo-horizontal-white.svg"
                alt="Clarantis"
                className="h-8 w-auto"
              />
            </Link>
            <p className="text-sm leading-6 text-primary-200">
              Clarity in Compliance. Modern GRC solutions for enterprise teams who need to move fast without compromising security.
            </p>
            {/* Social links */}
            <div className="flex space-x-6">
              {navigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-primary-300 hover:text-white transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item.name}
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>

          {/* Links sections */}
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              {/* Product links */}
              <div>
                <h3 className="text-sm font-semibold uppercase tracking-wider text-white">
                  Product
                </h3>
                <ul role="list" className="mt-4 space-y-3">
                  {navigation.product.map((item) => (
                    <li key={item.name}>
                      <Link
                        to={item.href}
                        className="text-sm text-primary-200 hover:text-white transition-colors"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Company links */}
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold uppercase tracking-wider text-white">
                  Company
                </h3>
                <ul role="list" className="mt-4 space-y-3">
                  {navigation.company.map((item) => (
                    <li key={item.name}>
                      <Link
                        to={item.href}
                        className="text-sm text-primary-200 hover:text-white transition-colors"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="md:grid md:grid-cols-2 md:gap-8">
              {/* Legal links */}
              <div>
                <h3 className="text-sm font-semibold uppercase tracking-wider text-white">
                  Legal
                </h3>
                <ul role="list" className="mt-4 space-y-3">
                  {navigation.legal.map((item) => (
                    <li key={item.name}>
                      <Link
                        to={item.href}
                        className="text-sm text-primary-200 hover:text-white transition-colors"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Contact info */}
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold uppercase tracking-wider text-white">
                  Get in Touch
                </h3>
                <div className="mt-4 space-y-3">
                  <p className="text-sm text-primary-200">
                    Ready to transform your compliance program?
                  </p>
                  <Link
                    to="/contact"
                    className="inline-flex items-center justify-center rounded-lg bg-accent-teal px-4 py-2 text-sm font-semibold text-primary-700 shadow-sm hover:bg-accent-mint transition-colors"
                  >
                    Request a Demo
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom section */}
        <div className="mt-12 border-t border-primary-600 pt-8">
          <div className="md:flex md:items-center md:justify-between">
            <p className="text-xs text-primary-300">
              &copy; {currentYear} Clarantis, Inc. All rights reserved.
            </p>
            <div className="mt-4 flex space-x-6 md:mt-0">
              <span className="text-xs text-primary-300">
                SOC 2 Type II Compliant
              </span>
              <span className="text-xs text-primary-300">
                ISO 27001 Certified
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
